/* BG-GLASS-VARIANT-20261023 (Rick t3722u, 2026-10-23)
   1) Included-glass engraving: Silver/Gold Fill tiles show the fill price (+$14.89) on top of the
      $14.89 etch, with the accurate etch+fill total. Charged amount (data-fee-amount / carrier
      variant) is NOT changed here: it already equals etch + fill.
   2) Wooden gift sets with a "Glencairn Glasses" variant: initials only, max 4 characters on
      glass 1 and 4 on glass 2; longer text / logo / design / fill => Old Fashioned variant.
   Rollback: delete this asset + the render line in snippets/bg-options-body.liquid. */
(function () {
  if (window.__bgGlassVariant) return; window.__bgGlassVariant = 1;
  var MAXC = 4;
  var FINISH = 'inc-old-fashioned-engraving-text-finish';
  var GC_HIDE = ['included-glasses-smooth-artwork', 'included-glasses-full-name', 'included-glasses-smooth-line-1',
    'included-glasses-smooth-line-2', 'included-glasses-logo-upload', 'included-glasses-custom-design',
    'included-glasses-custom-design-text'];
  var css = '.bg-tile .tag .bg-fill-sub{display:block;font-size:10px;line-height:1.2;opacity:.85;font-weight:400;margin-top:2px}' +
    'html.bg-gc-mode [data-bg-options-root] [data-key="' + FINISH + '"] [data-value="silver-fill"],' +
    'html.bg-gc-mode [data-bg-options-root] [data-key="' + FINISH + '"] [data-value="gold-fill"]' +
    GC_HIDE.map(function (k) { return ',html.bg-gc-mode [data-bg-options-root] [data-key="' + k + '"]'; }).join('') +
    '{display:none!important}' +
    '.bg-gc-note{font-size:12px;line-height:1.4;margin:6px 0 10px;opacity:.9}.bg-gc-note button{background:none;border:0;padding:0;color:inherit;text-decoration:underline;cursor:pointer;font:inherit}' +
    'html:not(.bg-gc-mode) .bg-gc-note{display:none}';
  var st = document.createElement('style'); st.setAttribute('data-bg-glass-variant', ''); st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  function money(n) { return '$' + (Math.round(n * 100) / 100).toFixed(2); }
  function amt(el) {
    if (!el) return 0;
    var a = parseFloat(el.getAttribute('data-fee-amount'));
    if (!(a > 0)) a = parseFloat(el.getAttribute('data-own-price'));
    return a > 0 ? a : 0;
  }
  function fixFills(root) {
    var fields = root.querySelectorAll('[data-key^="inc-"][data-key$="-text-finish"]');
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i], et = f.querySelector('[data-value="etched"]'), e = amt(et);
      if (!(e > 0)) continue;
      ['silver-fill', 'gold-fill'].forEach(function (v) {
        var t = f.querySelector('[data-value="' + v + '"]'); if (!t) return;
        var tot = amt(t); if (!(tot > e + 0.004)) return;
        var d = tot - e, tag = t.querySelector('.tag'); if (!tag) return;
        var html = '+' + money(d) + ' fill<span class="bg-fill-sub">Etch ' + money(e) + ' + fill = ' + money(tot) + '</span>';
        if (tag.getAttribute('data-bg-fill') !== html) { tag.innerHTML = html; tag.setAttribute('data-bg-fill', html); }
        var name = v === 'silver-fill' ? 'Silver Fill' : 'Gold Fill';
        var al = name + ': ' + money(e) + ' etch plus ' + money(d) + ' fill, ' + money(tot) + ' total';
        if (t.getAttribute('aria-label') !== al) t.setAttribute('aria-label', al);
      });
    }
  }

  var gcIds = null;
  function loadIds() {
    if (gcIds) return gcIds; gcIds = {};
    var els = document.querySelectorAll('script[data-bg-glass-variants]');
    for (var i = 0; i < els.length; i++) {
      try { var j = JSON.parse(els[i].textContent); (j.glencairn || []).forEach(function (id) { gcIds[String(id)] = 1; }); gcIds.__of = j.old_fashioned; gcIds.__opt = j.option; } catch (e) {}
    }
    return gcIds;
  }
  function currentVariant() {
    var inp = document.querySelector('form.js-product-form-main [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
    return inp ? String(inp.value) : '';
  }
  var labels = {};
  function setLabel(root, key, txt) {
    var f = root.querySelector('[data-key="' + key + '"]'); if (!f) return;
    var l = f.querySelector('.bg-field__label, label'); if (!l) return;
    if (!labels[key]) labels[key] = l.textContent;
    var want = txt == null ? labels[key] : txt;
    if (l.textContent !== want) l.textContent = want;
  }
  function headingEl(root) {
    var hs = root.querySelectorAll('.bg-field--heading');
    for (var i = 0; i < hs.length; i++) if (/Glasses That Are Included/i.test(hs[i].textContent)) return hs[i];
    return null;
  }
  function pressed(f, v) { var t = f && f.querySelector('[data-value="' + v + '"]'); return t && t.getAttribute('aria-pressed') === 'true' ? t : null; }
  function selectOF() {
    var ids = loadIds(), of = ids.__of; if (!of) return;
    var btn = document.querySelector('variant-picker input[value="Old Fashioned Glasses"], variant-selects input[value="Old Fashioned Glasses"], input[type="radio"][value="Old Fashioned Glasses"]');
    if (btn) { btn.click(); var lab = btn.id && document.querySelector('label[for="' + btn.id + '"]'); if (lab) lab.click(); return; }
    var sel = document.querySelector('select option[value="Old Fashioned Glasses"]');
    if (sel) { sel.parentNode.value = 'Old Fashioned Glasses'; sel.parentNode.dispatchEvent(new Event('change', { bubbles: true })); return; }
    location.search = '?variant=' + of;
  }
  function enforce(inp) {
    if (!inp || inp.__bgMax) return; inp.__bgMax = 1;
    inp.setAttribute('maxlength', String(MAXC));
    inp.addEventListener('input', function () {
      if (inp.value.length > MAXC) { inp.value = inp.value.slice(0, MAXC); inp.dispatchEvent(new Event('input', { bubbles: true })); inp.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  }
  function apply() {
    var roots = document.querySelectorAll('[data-bg-options-root]');
    var ids = loadIds(), gc = !!ids[currentVariant()];
    document.documentElement.classList.toggle('bg-gc-mode', gc);
    for (var r = 0; r < roots.length; r++) {
      var root = roots[r];
      fixFills(root);
      ['included-glasses-message-line-1', 'included-glasses-message-line-2'].forEach(function (k) {
        var f = root.querySelector('[data-key="' + k + '"]'); if (f) { var inp = f.querySelector('input,textarea'); enforce(inp); if (inp && inp.value.length > MAXC) { inp.value = inp.value.slice(0, MAXC); inp.dispatchEvent(new Event('input', { bubbles: true })); } }
      });
      var fin = root.querySelector('[data-key="' + FINISH + '"]'), h = headingEl(root);
      if (h && !h.__bgOrig) h.__bgOrig = h.textContent;
      if (gc) {
        if (h) { var ht = 'Engrave the Two Glencairn Glasses That Are Included'; if (h.textContent !== ht) h.textContent = ht; }
        setLabel(root, FINISH, 'Engraving for the Two Included Glencairn Glasses (initials only)');
        setLabel(root, 'included-glasses-message-line-1', 'Glencairn Glass 1 Initials (up to 4 characters)');
        setLabel(root, 'included-glasses-message-line-2', 'Glencairn Glass 2 Initials (up to 4 characters)');
        if (fin && !fin.querySelector('.bg-gc-note')) {
          var n = document.createElement('p'); n.className = 'bg-gc-note';
          n.innerHTML = 'Glencairn glasses: initials only, up to 4 characters per glass. Want a longer message, a logo, a design or a silver/gold fill? <button type="button" data-bg-gc-switch>Switch to Old Fashioned glasses</button>.';
          fin.appendChild(n);
          n.querySelector('[data-bg-gc-switch]').addEventListener('click', selectOF);
        }
        var fs = root.querySelector('[data-key="included-glasses-full-name"]'), p;
        if ((p = pressed(fs, 'smooth-full-name'))) p.click();
        if (pressed(fin, 'silver-fill') || pressed(fin, 'gold-fill')) { var ne = fin.querySelector('[data-value="no-engraving"]'); if (ne) ne.click(); }
      } else {
        if (h && h.__bgOrig && h.textContent !== h.__bgOrig) h.textContent = h.__bgOrig;
        setLabel(root, FINISH, null); setLabel(root, 'included-glasses-message-line-1', null); setLabel(root, 'included-glasses-message-line-2', null);
      }
    }
  }
  var busy = 0, q = 0;
  function schedule() { if (q) return; q = 1; setTimeout(function () { q = 0; if (busy) return; busy = 1; try { apply(); } finally { busy = 0; } }, 60); }
  function boot() {
    schedule();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('change', schedule, true);
    document.addEventListener('click', function () { setTimeout(schedule, 150); }, true);
    var last = currentVariant();
    setInterval(function () { var v = currentVariant(); if (v !== last) { last = v; schedule(); } }, 400);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
